export default __webpack_public_path__ + "static/media/movimenti-dark.dd63ccbd.svg";